import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import en from './locales/en'
import es from './locales/es'
import vi from './locales/vi'
import zh_TW from './locales/zh_TW'
import zh_hans from './locales/zh_hans'
import my from './locales/my'
import type { Locale } from './locales/en/index'

type Locales = {
  [key: string]: Locale
}

const resources: Locales = {
  en,
  es,
  vi,
  zh_hans,
  zh_TW,
  my,
}

i18n.use(initReactI18next).init({
  fallbackLng: 'en',
  resources,
  // debug: true,
  interpolation: {
    escapeValue: false,
  },
})

export default i18n
